// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from 'modules/queries/api';

/**
 * @param {import('club-sauce/public/product/index.raw').LWApiPublicProductPriceParamsRawI} params
 * @param {import('@tanstack/react-query').UseQueryOptions<import('club-sauce/public/product/index.raw').LWApiPublicProductPriceResultRawI>} [options]
 */
const useProductPrice = (params, options) =>
	useQuery({
		queryKey: ['/product/price', params],
		queryFn: () => api.product.apiRaw.price(params),
		...options,
	});

export default useProductPrice;
